import React from 'react';
import ReactDOM from 'react-dom/client';
import {LadybugLayout} from './ladybug/jsx/layouts/LadybugLayout';
import './styles/app.scss';
import './ladybug/styles/app.scss';
import reportWebVitals from './reportWebVitals';
import { CommonUtil } from 'ladybug/jsx/utils/CommonUtil';
import { telegramMock } from 'telegram.consts';

// Set Window Size
const webApp = window.Telegram.WebApp;
CommonUtil().setWindowSize(webApp);
window.addEventListener('resize', () => CommonUtil().setWindowSize(webApp), false);
webApp.onEvent('viewportChanged', isStateStable => isStateStable && CommonUtil().setWindowSize(webApp));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LadybugLayout />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
